import { render, staticRenderFns } from "./SetupWizardIndex.vue?vue&type=template&id=7f37960d&scoped=true"
import script from "./SetupWizardIndex.vue?vue&type=script&lang=js"
export * from "./SetupWizardIndex.vue?vue&type=script&lang=js"
import style0 from "./SetupWizardIndex.vue?vue&type=style&index=0&id=7f37960d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f37960d",
  null
  
)

export default component.exports